import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SimsRoutingModule } from './sims-routing.module';
import { SimOperatorTreeViewComponent } from './components/sim-operator-tree-view/sim-operator-tree-view.component';
import { SimTrainTreeViewComponent } from './components/sim-train-tree-view/sim-train-tree-view.component';
import { SharedModule } from '../../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { SimListComponent } from './components/sim-list/sim-list.component';
import { SIMS_STATES } from './sims.states';
import { TrainSimsUsageComponent } from './containers/train-sims-usage/train-sims-usage.component';
import { SimsConfigurationComponent } from './containers/sims-configuration/sims-configuration.component';
import { SimEditComponent } from './components/sim-edit/sim-edit.component';
import { SimAlarmColorPipe } from './pipes/sim-alarm-color.pipe';
import { UniqueModemsPipe } from './pipes/unique-modems.pipe';
import { SimUniqueValuesPipe } from './pipes/sim-unique-values.pipe';
import { TrainsModule } from '../trains/trains.module';
import { SimConsumptionPeriodSelectorComponent } from './components/sim-consumption-period-selector/sim-consumption-period-selector.component';
@NgModule({
  declarations: [SimOperatorTreeViewComponent, SimTrainTreeViewComponent, SimListComponent, TrainSimsUsageComponent, SimsConfigurationComponent, SimEditComponent, SimAlarmColorPipe,UniqueModemsPipe, SimUniqueValuesPipe, SimConsumptionPeriodSelectorComponent],
  imports: [
    SharedModule,
    SimsRoutingModule,
    UIRouterModule.forChild({ states: [...SIMS_STATES]  }), 
    TrainsModule
  ],
  exports: [
    TrainSimsUsageComponent
  ],
  entryComponents: [
    SimOperatorTreeViewComponent,
    SimTrainTreeViewComponent
  ]
})
export class SimsModule { }
